export default __webpack_public_path__ + "static/media/Group117979.1890cfe3.svg";